import { shouldFetch } from "../helpers/api";
import { buildNextUrl, history } from "../helpers/history";
import { priceEstimated } from "../helpers/schema";
import { CALL_API } from "../middleware/api";

// ----------------------
// Price Fetching
// ----------------------
export const FETCH_PRICESESTIMATED_REQUEST = "FETCHPRICEESTIMATED_REQUEST";
export const FETCH_PRICESESTIMATED_SUCCESS = "FETCH_PRICEESTIMATED_SUCCESS";
export const FETCH_PRICESESTIMATED_FAILURE = "FETCH_PRICEESTIMATED_FAILURE";
export const INVALIDATE_PRICESESTIMATED = "INVALIDATE_PRICEESTIMATED";

function invalidatePricesEstimated() {
  return { type: INVALIDATE_PRICESESTIMATED };
}

function fetchPricesEstimatedIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetch(getState(), "pricesEstimated")) {
      return dispatch(fetchPricesEstimated());
    }
  };
}

const fetchPricesEstimated = () => ({
  [CALL_API]: {
    types: [
      FETCH_PRICESESTIMATED_REQUEST,
      FETCH_PRICESESTIMATED_SUCCESS,
      FETCH_PRICESESTIMATED_FAILURE,
    ],
    endpoint: `price_estimateds?pagination=false`,
    schema: [priceEstimated],
  },
});

// ----------------------
// Price Edit
// ----------------------

export const EDIT_PRICEESTIMATED_REQUEST = "EDIT_PRICEESTIMATED_REQUEST";
export const EDIT_PRICEESTIMATED_RESPONSE = "EDIT_PRICEESTIMATED_RESPONSE";
export const EDIT_PRICEESTIMATED_ERROR = "EDIT_PRICEESTIMATED_ERROR";

const edit = (form) => (dispatch, getState) => {
  dispatch({
    [CALL_API]: {
      types: [
        EDIT_PRICEESTIMATED_REQUEST,
        EDIT_PRICEESTIMATED_RESPONSE,
        EDIT_PRICEESTIMATED_ERROR,
      ],
      endpoint: `price_estimateds/` + form.id,
      schema: priceEstimated,
      requestOptions: {
        method: "PUT", // 16/02 : had to use PUT instead of PATCH after updating API platform from 2.5.7 to 2.6.2
        headers: { "content-type": "application/json" },
        body: JSON.stringify(form),
      },
      success: (result) => {
        history.push(buildNextUrl(getState()));
      },
    },
  });
};

export const pricesEstimatedActions = {
  invalidatePricesEstimated,
  fetchPricesEstimatedIfNeeded,
  edit,
};
